import { isServer } from '@tunein/web-utils';
import { TUNEIN_REFRESH_TOKEN } from '../constants/headers';
import tuneInRequest from '../tuneInRequest';
export default function reauthService(config, apiContext) {
    const proxyReauthEndpoint = `${config.domains.local}/auth/reauth/`;
    const reauthEndpoint = `${config.domains.opml}/oauth/access_token`;
    let auth;
    if (config.auth) {
        auth = {
            username: config.auth.clientId,
            password: config.auth.clientSecret,
        };
    }
    function proxyReauth() {
        return tuneInRequest({
            method: 'post',
            url: proxyReauthEndpoint,
            isAjax: true,
            disableRetry: true,
            ...(config.isStaticClient && {
                headers: {
                    [TUNEIN_REFRESH_TOKEN]: apiContext.getTokens().refreshToken,
                },
            }),
        }, apiContext);
    }
    function reauth() {
        if (!isServer()) {
            return proxyReauth();
        }
        return tuneInRequest({
            method: 'post',
            url: reauthEndpoint,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            auth,
            data: new URLSearchParams({
                refreshToken: apiContext.getTokens().refreshToken,
            }).toString(),
            disableRetry: true,
        }, apiContext);
    }
    return reauth;
}
